export const brStates = [
  { state: 'Acre', abbr: 'ac' },
  { state: 'Alagoas', abbr: 'al' },
  { state: 'Amapá', abbr: 'ap' },
  { state: 'Amazonas', abbr: 'am' },
  { state: 'Bahia', abbr: 'ba' },
  { state: 'Ceará', abbr: 'ce' },
  { state: 'Distrito Federal', abbr: 'df' },
  { state: 'Espírito Santo', abbr: 'es' },
  { state: 'Goiás', abbr: 'go' },
  { state: 'Maranhão', abbr: 'ma' },
  { state: 'Mato Grosso', abbr: 'mt' },
  { state: 'Mato Grosso do Sul', abbr: 'ms' },
  { state: 'Minas Gerais', abbr: 'mg' },
  { state: 'Pará', abbr: 'pa' },
  { state: 'Paraíba', abbr: 'pb' },
  { state: 'Paraná', abbr: 'pr' },
  { state: 'Pernambuco', abbr: 'pe' },
  { state: 'Piauí', abbr: 'pi' },
  { state: 'Rio de Janeiro', abbr: 'rj' },
  { state: 'Rio Grande do Norte', abbr: 'rn' },
  { state: 'Rio Grande do Sul', abbr: 'rs' },
  { state: 'Rondônia', abbr: 'ro' },
  { state: 'Roraima', abbr: 'rr' },
  { state: 'Santa Catarina', abbr: 'sc' },
  { state: 'São Paulo', abbr: 'sp' },
  { state: 'Sergipe', abbr: 'se' },
  { state: 'Tocantins', abbr: 'to' }
]

export const themes = [
  { name: 'Sea', value: 'sea' },
  { name: 'Night sky', value: 'night_sky' },
  { name: 'Winter', value: 'winter' },
  { name: 'Sun', value: 'sun' }
]
